module.exports = __webpack_public_path__ + "static/TownOfLight1-b8e0d030aa925fa35f4072a1338bf845.webp";